export const NYC_SEO_SERVICES_PAGE_LOADER = "NYC_SEO_SERVICES_PAGE_LOADER";
export const NYC_SEO_SERVICES_PAGE_SUCCESS = "NYC_SEO_SERVICES_PAGE_SUCCESS";
export const NYC_SEO_SERVICES_PAGE_FAILURE = "NYC_SEO_SERVICES_PAGE_FAILURE";
export const NYC_SEO_SERVICES_PAGE_RESET = "NYC_SEO_SERVICES_PAGE_RESET";